import { combineReducers } from 'redux'

import notFoundRoutes from './not-found-routes'
import locale from './locale'
import app from './app'
import auth from './auth'
import superAdmin from './super-admin'
import devices from './devices'
import deviceOilHistory from './device-oil-history'

/**
 * Root reducer combining all feature reducers.
 */
const rootReducer = combineReducers({
    notFoundRoutes,
    locale,
    app,
    auth,
    superAdmin,
    devices,
    deviceOilHistory,
})

export default rootReducer
